import { useState, useEffect } from 'react';
const useForm = (callback, validate, props) => {
	const [errors, setErrors] = useState({});
	const [fields, setFields] = useState({
		firstname: {name: 'firstname', required: true, type: 'text', value: props.personalInformation.firstname, error: errors.firstname},
		lastname: {name: 'lastname', required: true, type: 'text', value: props.personalInformation.lastname, error: errors.lastname},
		email: {name: 'email', required: true, type: 'email', value: props.personalInformation.email, error: errors.email},
		phone: {name: 'phone', required: true, type: 'tel', value: props.personalInformation.phone, error: errors.phone},
		country: {name: 'country', type: 'text', value: props.personalInformation.country, error: errors.country},
		company: {name: 'company', required: true, type: 'text', value: props.personalInformation.company, error: errors.company},
		industry: {name: 'industry', type: 'text', value: props.personalInformation.industry, error: errors.industry},
		companysize: {name: 'companysize', type: 'number', value: props.personalInformation.companysize, error: errors.companysize},
		description: {name: 'description', required: true, value: props.personalInformation.description},
		newsletter: {name: 'newsletter', type: 'checkbox', checked: props.personalInformation.newsletter},
	});

	useEffect(() => {
		let valid = true;
		let fieldsArray = Object.values(fields)
		let newField = {}
		fieldsArray.forEach((target) => {
			if(target.required && target.type !=='checkbox') {
				if(target.value === '' || target.error ) {
					valid = false
				}
			} else if(target.required && target.type === 'checkbox') {
				if((!target.checked) || target.error) {
					valid = false
				}
			}

			target.type === 'checkbox' ? newField[target.name] = target.checked : newField[target.name] = target.value
		})

		callback(newField, valid);
	},[fields]);

	const handleChange = (event) => {
		event.persist();
		let fieldsCopy = {...fields};
		fieldsCopy[event.target.name] = {...fields[event.target.name], value: event.target.value}
		setFields(fieldsCopy)
		setErrors(validate(fieldsCopy, event.target.name))
	};

	const handleClick = (event) => {
		event.persist();
		let fieldsCopy = {...fields};
		fieldsCopy[event.target.name] = {...fields[event.target.name], checked: event.target.checked}
		setFields(fieldsCopy)
		setErrors(validate(fieldsCopy, event.target.name));
	}
	
	return {
		handleChange,
		handleClick,
		errors, 
		fields
	}
};

export default useForm;